module.exports = __webpack_public_path__ + "img/index03.868497b2.svg";